import React from 'react';
import {
  createStyles,
  makeStyles,
  Grid,
} from '@material-ui/core';
import { useField } from 'formik';
import clsx from 'clsx';

import noop from '../../utility/noop';
import ColorPicker from '../color-picker/ColorPicker';

const useStyles = makeStyles(createStyles({
  root: {
    marginBottom: '0px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    verticalAlign: 'middle',
  },
}), { name: 'FormColorPicker' });

type Props = {
  name: string;
  label: string;
  disabled?: boolean;
};

const FormColorPicker = ({
  name,
  label,
  disabled = false,
}: Props) => {
  const classes = useStyles();
  const [field] = useField({ name });

  return (
    <Grid className={clsx(classes.root)}>
      <span className={classes.label}>{label}</span>
      <ColorPicker
        name={name}
        value={field.value}
        onChange={disabled ? noop : field.onChange}
        disabled={disabled}
      />
    </Grid>
  );
};

export default FormColorPicker;
